import { gql } from 'graphql-request'

export const GET_LIVES_GUESTS_BY_LIVE_ID = gql`
  query GET_LIVES_GUESTS_BY_LIVE_ID($liveId: Int!) {
    getLiveGuestsByLiveId(liveId: $liveId) {
      error
      status
      data {
        id
        accepted
        liveId
        position
        rejected
        requesting
        blocked
        invited
        audioMuted
        videoBlocked
        audioOpen
        videoOpen
        userId
        user {
          id
          username
          imgUser
          birthday
          gender
          privacy {
            invisibleVisitor
          }
        }
      }
    }
  }
`

export const UPDATE_LIVE_DETAIL_GUEST = gql`
  mutation UPDATE_LIVE_DETAIL_GUEST(
    $liveDetailGuestId: Int!
    $liveId: Int!
    $requesting: Boolean
    $accepted: Boolean
    $rejected: Boolean
    $position: Int
    $audioOpen: Boolean
    $videoOpen: Boolean
    $videoBlocked: Boolean
  ) {
    updateLiveDetailGuest(
      liveDetailGuestId: $liveDetailGuestId
      liveId: $liveId
      requesting: $requesting
      accepted: $accepted
      rejected: $rejected
      position: $position
      audioOpen: $audioOpen
      videoOpen: $videoOpen
      videoBlocked: $videoBlocked
    ) {
      error
      status
      data {
        accepted
        audioMuted
        videoBlocked
        audioOpen
        invited
        blocked
        createdAt
        dateJoined
        dateLeaved
        id
        liveId
        position
        rejected
        requesting
        totalTime
        updatedAt
        userId
        videoOpen
      }
    }
  }
`
